/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Search Results Current Destination
 * Icon component.
 */
export const SearchResultsCurrentDestinationIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 32 42' fill='none'>
      <path d='M16.5 10.5v13'
        stroke={iconColor}
        strokeMiterlimit={16}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeDasharray='1 3' />
      <circle cx={16.5} cy={4.5} r={2.9} stroke={iconColor} strokeWidth={0.8} />
      <path d='M16.163 26.716a.523.523 0 01.688 0l4.445 3.94a.478.478 0 01.083.628l-4.444 6.612a.52.52 0 01-.855 0l-4.451-6.633a.478.478 0 01.084-.63l4.45-3.917z'
        clipRule='evenodd'
        stroke={iconColor}
        strokeWidth={0.8}
        strokeLinecap='round'
        strokeLinejoin='round' />
      <path d='M16.521 33.603c.976 0 1.793-.766 1.793-1.742s-.817-1.742-1.793-1.742c-.975 0-1.792.766-1.792 1.742s.817 1.742 1.793 1.742z'
        stroke={iconColor}
        strokeWidth={0.8} />
    </svg>
  );
};
